import { render, staticRenderFns } from "./ListCommunes.vue?vue&type=template&id=3481296d&"
import script from "./ListCommunes.vue?vue&type=script&lang=js&"
export * from "./ListCommunes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3481296d')) {
      api.createRecord('3481296d', component.options)
    } else {
      api.reload('3481296d', component.options)
    }
    module.hot.accept("./ListCommunes.vue?vue&type=template&id=3481296d&", function () {
      api.rerender('3481296d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListCommunes.vue"
export default component.exports